export default __webpack_public_path__ + "static/media/editor-bold-btn-icon.d5a32719.svg";